import { connect } from 'react-redux'
import { PropertyForm } from '../../components'
import { chatbotEvents, chatbotSelectors, getPropertyInitialValues, propertyDetailsEvents } from 'modules/ui/ChatBot'
import { portfolioApiSelectors } from '../../../modules/api/portfolio'
import { userApiSelectors } from '../../../modules/api/user'
import { $TSFixMe } from 'types/ts-migrate'

const mapStateToProps = (state: any) => {
  const currentPortfolioId = chatbotSelectors.getCurrentPortfolioId(state)
  return {
    currentPortfolioId,
    initialValues: getPropertyInitialValues(state),
    isActivePortfolio: portfolioApiSelectors.isActivePortfolio(state)(currentPortfolioId),
    isDraftPortfolio: portfolioApiSelectors.isDraftPortfolio(state)(currentPortfolioId),
    isReadonly: userApiSelectors.isReadOnlyRole(state),
  }
}

const mapDispatchToProps = (dispatch: any) => {
  return {
    clearSelection: () => dispatch(propertyDetailsEvents.clearSelection()),
    handleConfirmation: (values: $TSFixMe) => {
      dispatch(chatbotEvents.propertyConfirmationRequested(values))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PropertyForm)
